<p-dialog
  [(visible)]="showUploader"
  (onHide)="resetTabs(); onClose.emit()"
  [modal]="true"
  [style]="{ width: '70vw', height: '75vh' }"
  [resizable]="false"
>
  <ng-template class="block" pTemplate="header">
    <div class="header-container">
      <div
        class="header inline-flex align-items-center justify-content-center gap-2"
      >
        <h3>Upload Assets</h3>
      </div>
      <div class="subheader">
        Select an Asset Type then drag and drop or browse to upload
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <p-tabView [style]="{ height: '100%' }" [(activeIndex)]="activeIndex">
      <p-tabPanel
        *ngFor="let tab of tabs | keyvalue : origOrder"
        [header]="tab.key"
        [disabled]="tab.key === 'Audio' && (audioFlag$ | async) === false"
      >
        <p-messages
          *ngIf="tab.key === 'Audio'"
          [value]="audioCreativeInfo"
          [enableService]="false"
        >
        </p-messages>
        <div class="flex content-container">
          <div
            class="left-panel"
            [ngClass]="{ 'left-panel--with-table': tab.value.length > 0 }"
          >
            <div
              #upload
              class="flex flex-column justify-content-center upload-container"
              [ngStyle]="{ height: tab.value.length > 0 ? '50%' : '100%' }"
              (dragover)="onDragOver($event)"
              [id]="'div-' + tab.key"
              (drop)="selectFiles($event, 'drop')"
            >
              <fa-icon
                class="fa-3x fa-icon"
                [style.color]="'var(--primary-color)'"
                [icon]="uploadIcon"
              ></fa-icon>
              <div class="flex gap-2 ml-5">
                <span class="file-uploader"
                  >Drag and drop files here or
                  <span class="browse" (click)="openFileInput(tab.key)"
                    >browse</span
                  >
                  to select files</span
                >

                <input
                  #fileInput
                  multiple
                  type="file"
                  style="display: none"
                  [id]="'fi-' + tab"
                  (change)="selectFiles($event, 'browse')"
                />
              </div>
            </div>
            <ng-container *ngIf="tab.value.length > 0">
              <br />
              <br />
              <ng-container
                [ngTemplateOutlet]="uploadTable"
                [ngTemplateOutletContext]="{
                  tab: tab.key,
                  creatives: tab.value
                }"
              ></ng-container>
            </ng-container>
          </div>
          <div class="right-panel">
            <ng-container *ngIf="tab.key === 'Image'">
              <div class="panel-title">Image Upload Specifications:</div>
              <br />
              <div class="spec-title">Display Specs</div>
              <div class="spec-text">
                160x600, 300x50, 300x250, 300x600, 320x50, 320x480, 728x90,
                970x250, 1024x768
              </div>
              <div class="spec-title">File Types</div>
              <div class="spec-text">
                .png, .jpg, .jpeg, .gif, .zip (HTML5), x-zip-compressed
                <div class="pt-3">
                  Recommended file size is &lt;150kb (800kb max)
                </div>
              </div>
              <div class="spec-title">Resources</div>
              <a
                class="help-link"
                target="_blank"
                href="https://support.terminus.com/hc/en-us/articles/206622507-Terminus-Display-Advertising-Guidelines-Specifications"
                >What Ad Sizes and Formats does DemandScience Accept?
                <fa-icon
                  class="pl-1 external-svg"
                  [icon]="externalIcon"
                ></fa-icon
              ></a>
            </ng-container>
            <ng-container *ngIf="tab.key === 'CTV'">
              <div class="panel-title">Connected TV Upload Specifications:</div>
              <br />
              <div class="spec-title">Resolution</div>
              <div class="spec-text">16:9 1920x1080, 1280x720</div>
              <div class="spec-title">Maximum File Size</div>
              <div class="spec-text">10 GB</div>
              <div class="spec-title">Length</div>
              <div class="spec-text">Up to 60 seconds, 15-30 is best</div>
              <div class="spec-title">Frame Rate</div>
              <div class="spec-text">23.98 or 29.97</div>
              <div class="spec-title">Audio Sample Rate</div>
              <div class="spec-text">48kHz</div>
              <div class="spec-title">File Types</div>
              <div class="spec-text">.mp4</div>
              <div class="spec-title">Resolution (Bitrate Range)</div>
              <div class="spec-text">
                <div>4000 kbps to 6500 kbps works for most advertisers,</div>
                <div>15,025 kbps or higher required for Hulu</div>
              </div>
              <div class="spec-title">Resources</div>
              <a
                class="help-link"
                target="_blank"
                href="https://support.terminus.com/hc/en-us/articles/4406206973587-A-Guide-to-Connected-TV-CTV-Ads-in-Ad-Experiences"
                >A Guide to Connected TV (CTV) Ads in Ad Experiences
                <fa-icon
                  class="pl-1 external-svg"
                  [icon]="externalIcon"
                ></fa-icon
              ></a>
            </ng-container>
            <ng-container *ngIf="tab.key === 'Video'">
              <div class="panel-title">Video Upload Specifications:</div>
              <br />
              <div class="spec-title">Resolution</div>
              <div class="spec-text">
                <div>16:9 640x360 (min); 1920x1080 (recommended)</div>
                <div>4:3 480x360 (min); 640x480 (recommended)</div>
              </div>
              <div class="spec-title">Length</div>
              <div class="spec-text">Up to 60 seconds, 15-30 is best</div>
              <div class="spec-title">Frame Rate</div>
              <div class="spec-text">23.98 or 29.97</div>
              <div class="spec-title">Audio Sample Rate</div>
              <div class="spec-text">48kHz</div>
              <div class="spec-title">File Types</div>
              <div class="spec-text">.mp4, .WebM, .mov, .mpg, .mpeg</div>
              <div class="spec-title">Bit Rate</div>
              <div class="spec-text">Greater than or equal to 2500 kbps</div>
              <div class="spec-title">Resources</div>
              <a
                class="help-link"
                target="_blank"
                href="https://support.terminus.com/hc/en-us/articles/4423262040467-A-Guide-to-Video-Ads-in-Ad-Experiences"
                >A Guide to Video Ads in Ad Experiences
                <fa-icon
                  class="pl-1 external-svg"
                  [icon]="externalIcon"
                ></fa-icon
              ></a>
            </ng-container>
            <ng-container *ngIf="tab.key === 'Audio'">
              <div class="panel-title">Audio Upload Specifications</div>
              <br />
              <div class="spec-title">Audio Specs</div>
              <div class="spec-text">
                <div>File size must be under 10MB</div>
                <div>Length under 60 seconds</div>
              </div>
              <div class="spec-title">File Types</div>
              <div class="spec-text">.mp3, .wav, .mp4</div>
              <div class="spec-title">Resolution (Bitrate Range)</div>
              <div class="spec-text">160 kbps</div>
              <div class="spec-text">
                Hosted mp3 files should have a constant bitrate
              </div>
              <div class="spec-title">Resources</div>
              <a
                class="help-link"
                target="_blank"
                href="https://support.terminus.com/hc/en-us/articles/4406213411603-A-Guide-to-Audio-Ads-in-Ad-Experiences"
                >A Guide to Audio Ads in Ad Experiences
                <fa-icon
                  class="pl-1 external-svg"
                  [icon]="externalIcon"
                ></fa-icon
              ></a>
            </ng-container>
          </div>
        </div>
      </p-tabPanel>
    </p-tabView>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button
      styleClass="p-button-primary"
      label="Done"
      (click)="showUploader = false"
    ></p-button>
  </ng-template>
</p-dialog>

<!-- Table template for each creative type/tab -->
<ng-template #uploadTable let-tab="tab" let-creatives="creatives">
  <p-table [value]="creatives" dataKey="asset.id">
    <ng-template pTemplate="header">
      <tr>
        <th class="thumbnail-col"></th>
        <th class="asset-name-col">Asset Name</th>
        <th class="delete-col"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-creative>
      <tr>
        <td>
          <div
            class="flex align-items-center justify-content-center gap-3 name"
          >
            <ng-container [ngSwitch]="creative.asset?.assetType">
              <ng-container *ngSwitchDefault>
                <tux-svg
                  class="error-svg"
                  *ngIf="
                    (creative.uploadError || creative.validationError) &&
                      creative.completed;
                    else spinner
                  "
                  [src]="fileError"
                ></tux-svg>
                <ng-template #spinner>
                  <p-progressSpinner
                    styleClass="tux-spinner"
                    aria-label="Loading"
                    [style]="{ width: '48px', height: '48px' }"
                  ></p-progressSpinner>
                </ng-template>
              </ng-container>

              <ng-container *ngIf="creative.asset.ready">
                <ng-container *ngSwitchCase="'IMAGE_ASSET'">
                  <div>
                    <img
                      class="thumbnail"
                      *ngIf="creative.asset.version.imageDisplay.imageSrc"
                      [src]="
                        safeUrl(creative.asset.version.imageDisplay.imageSrc)
                      "
                      [attr.alt]="creative.asset.fileName"
                    />
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'CTV_ASSET'">
                  <video
                    class="thumbnail"
                    *ngIf="creative.asset.version.videoDisplay.videoSrc"
                  >
                    <source
                      [src]="
                        safeUrl(creative.asset.version.videoDisplay.videoSrc)
                      "
                      type="video/mp4"
                    />
                  </video>
                </ng-container>

                <ng-container *ngSwitchCase="'VIDEO_ASSET'">
                  <video
                    class="thumbnail"
                    *ngIf="creative.asset.version.videoDisplay.videoSrc"
                  >
                    <source
                      [src]="
                        safeUrl(creative.asset.version.videoDisplay.videoSrc)
                      "
                      [type]="creative.asset.mimeType"
                    />
                  </video>
                </ng-container>

                <ng-container *ngSwitchCase="'AUDIO_ASSET'">
                  <tux-svg [src]="MusicSvg"></tux-svg>
                </ng-container>

                <ng-container *ngSwitchCase="'HTML5_ASSET'">
                  <iframe
                    class="thumbnail"
                    *ngIf="
                      creative?.asset?.version?.customerFacingStatusMessage ===
                        'READY' &&
                      creative?.asset?.version?.html5Display?.previewSrc
                    "
                    scrolling="no"
                    frameborder="0"
                    [attr.src]="
                      creative?.asset?.version?.html5Display?.previewSrc | safe
                    "
                  >
                  </iframe>
                  <tux-svg
                    *ngIf="
                      creative?.asset?.version?.customerFacingStatusMessage !==
                        'READY' ||
                      !creative.asset.version.html5Display.previewSrc
                    "
                    [src]="HTML5Svg"
                  ></tux-svg>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </td>
        <td>
          <div class="progress">
            <span class="pb-1">{{
              creative.asset?.fileName || creative.asset?.name
            }}</span>
            <p-progressBar
              *ngIf="creative.uploadProgress || creative.completed"
              [mode]="
                creative.uploadProgress === 100 && !creative.completed
                  ? 'indeterminate'
                  : 'determinate'
              "
              styleClass="progress-bar"
              [showValue]="false"
              [ngClass]="{
                'complete-bar': creative.completed && !creative.uploadError && !creative.validationError,
                'error-bar': creative.completed && (creative.uploadError || creative.validationError),
              }"
              [value]="creative.uploadProgress || 0"
            ></p-progressBar>
            <div
              class="upload-error-message"
              *ngIf="creative.validationError || creative.uploadError"
            >
              <fa-icon [icon]="diamondExclamation"></fa-icon>
              {{ creative.validationError || creative.uploadError }}
            </div>
          </div>
        </td>
        <td>
          <fa-icon
            class="trash"
            [icon]="trashIcon"
            (click)="removeCreative(creative, creatives)"
          ></fa-icon>
        </td>
      </tr>
    </ng-template>
  </p-table>
</ng-template>
